import { createAsyncThunk } from '@reduxjs/toolkit';
import { _teleServicePriceUrls } from '@custom/Utils/constants/apiUrls';

type payloadType = {
  doctorId: string;
  _id: string;
  services: {
    modality: string;
    studyRegion: string;
    price: number;
  }[];
};

// Async thunk to edit a teleservice price
export const editTeleServicePrice = createAsyncThunk(
  'editTeleServicePrice',
  async (payload: payloadType, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_teleServicePriceUrls?.edit, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response?.ok) {
        return rejectWithValue(`Failed to edit teleservice price. Status code: ${response?.status}`);
      }

      return await response.json(); // Return the response data if successful
    } catch (error: any) {
      return rejectWithValue(error.message); // Handle any errors that occur
    }
  }
);

export default editTeleServicePrice;
